import React from "react";
import Avatar from "../avatar";
import { formatUserName } from "../../libs/formatName";

const ReadInfo = ({
	partners,
	lastReadByPartners,
	userId,
	senderId,
}: {
	partners;
	lastReadByPartners: string[];
	userId: string;
	senderId: string;
}) => {
	return (
		<>
			{lastReadByPartners ? (
				<div className="readIndicator">
					{lastReadByPartners
						.filter((partnerId: string) => {
							return partnerId !== userId && partnerId !== senderId;
						})
						.map((partnerId: string, key: number) => {
							if (partners[partnerId]) {
								return (
									<Avatar
										photoUrl={partners[partnerId].photoUrl}
										key={key}
										title={formatUserName(partners[partnerId])}
									/>
								);
							}
						})}
				</div>
			) : null}
		</>
	);
};

export default ReadInfo;
